import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useServices(props, emit, service) {

    // Get toast interface
    const toast = useToast()

    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getServices = () => {
        store.dispatch("getServices")
    }


    const onSubmit = () => {
        loading.value = true

        if (service.value.id) {
            store.dispatch('updateService', service.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("Der Dienst wurde erfolgreich aktualisiert!", {
                            timeout: 3000,
                        })
                        store.dispatch("getServices")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })

        } else {

            store
                .dispatch("createService", service.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success("Dienst erfolgreich hinzugefügt!", {
                            timeout: 3000,
                        })
                        store.dispatch("getServices")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }

    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        service.value.service_column_image = null
        service.value.service_page_image = null
        emit("close")
    }


    return {
        show,
        loading,
        errors,
        getServices,
        onSubmit,
        closeModal,
    }
}